import 'gridstrap/svg-symbols/facebook.svg?sprite';
import 'gridstrap/svg-symbols/twitter.svg?sprite';
import 'gridstrap/svg-symbols/linkedin.svg?sprite';
import 'gridstrap/svg-symbols/google-plus.svg?sprite';
import 'gridstrap/svg-symbols/rss.svg?sprite';
import 'gridstrap/svg-symbols/youtube.svg?sprite';

import './share-buttons.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSShareButtons } from './share-buttons';

components.register({
	selector: '.gs-ShareButtons',
	controller: GSShareButtons
});

